import React, {useEffect} from "react";

const NotFound=()=>{
     useEffect(() => {
                    document.title =
                      "Page Not Found | VigoFlex Tile Adhesives";
                
                    const metaDesc = document.querySelector("meta[name='description']");
                    if (metaDesc) {
                      metaDesc.setAttribute(
                        "content",
                        "The page you’re looking for doesn’t exist or has been moved. Explore VigoFlex’s range of tile adhesives or return to the homepage for the right solution."
                      );
                    }
                
                     const canonical = document.querySelector("link[rel='canonical']");
                  if (canonical) {
                    canonical.setAttribute("href", "https://vigoflex.in/404");
                  }
                
                  const ogTitle = document.querySelector("meta[property='og:title']");
                  if (ogTitle) {
                    ogTitle.setAttribute(
                      "content",
                      "Page Not Found | VigoFlex Tile Adhesives"
                    );
                  }
                
                    const ogDesc = document.querySelector("meta[property='og:description']");
                  if (ogDesc) {
                    ogDesc.setAttribute(
                      "content",
                      "The page you’re looking for doesn’t exist or has been moved. Explore VigoFlex’s range of tile adhesives or return to the homepage for the right solution."
                    );
                  }
                
                  const ogUrl = document.querySelector("meta[property='og:url']");
                  if (ogUrl) {
                    ogUrl.setAttribute("content", "https://vigoflex.in/404");
                  }
                
                    const ogImage = document.querySelector("meta[property='og:image']");
                  if (ogImage) {
                    ogImage.setAttribute(
                      "content",
                      "https://vigoflex.in/files/home-img.webp"
                    );
                  }
                
                    const twitterTitle = document.querySelector("meta[name='twitter:title']");
                  if (twitterTitle) {
                    twitterTitle.setAttribute(
                      "content",
                      "Page Not Found | VigoFlex Tile Adhesives"
                    );
                  }
                
                    const twitterDesc = document.querySelector(
                    "meta[name='twitter:description']"
                  );
                  if (twitterDesc) {
                    twitterDesc.setAttribute(
                      "content",
                      "The page you’re looking for doesn’t exist or has been moved. Explore VigoFlex’s range of tile adhesives or return to the homepage for the right solution."
                    );
                  }
                
                    const twitterImage = document.querySelector("meta[name='twitter:image']");
                  if (twitterImage) {
                    twitterImage.setAttribute(
                      "content",
                       "https://vigoflex.in/files/home-img.webp"
                    );
                  }

                  let robots = document.querySelector("meta[name='robots']");

if (!robots) {
  robots = document.createElement("meta");
  robots.setAttribute("name", "robots");
  document.head.appendChild(robots);
}

robots.setAttribute(
  "content",
  "noindex, follow"
);
                  }, [])
    return(
        <>
        <section className="container not-found-section">
             <h1 className="section-heading">404<br />Page Not Found!</h1>
            <p className="section-text"> The page you are looking for is not available or has been moved. Try a different page or go to
                  homepage with the button below.</p>
      <a
          href="/"
            className="btn btn-primary"
          >
        Go To Homepage
          </a>
        </section>
        </>
    )
}
export default NotFound;